var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stats"},[_c('div',{staticClass:"stat"},[_c('div',{staticClass:"label"},[_vm._v("Started on")]),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm._f("shortDate")(_vm.assignment.started_at)))])])])}
var staticRenderFns = []

export { render, staticRenderFns }